module.exports = __webpack_public_path__ + "2cac96ce68f402d70a46b10b98a9fceb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/ii/ii05.jpg
// module id = 651
// module chunks = 0